import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BsFillSearchHeartFill, BsMicFill } from "react-icons/bs";
import { BiCurrentLocation } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import { BsChevronDown } from "react-icons/bs";
import { BsChevronUp } from "react-icons/bs";
import { Badge } from "react-bootstrap";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { searchPost } from "../../../redux/search/SearchSlice";
import { getSubCategory } from "../../../redux/subCategory/SubCategorySlice";
import ReactSlider from "react-slider";

const BuySearchComponent = (props) => {
  const { subCatTotal } = useSelector((store) => store.SubCategory);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useRef();

  const [showResults, setShowResults] = useState(false);
  const [toggle, setToggle] = useState("");

  const [showSubcat, setShowSubcat] = useState([
    { name: "Flat/apartment" },
    { name: "Independent House" },
    { name: "Villa" },
    { name: "Independent/Builder Floor" },
  ]);
  const [selectedSubcat, setSelectedSubcat] = useState([
    "Flat/apartment",
    "Independent House",
    "Villa",
    "Independent/Builder Floor",
  ]);
  const [selectedBedrooms, setSelectedBedrooms] = useState([]);
  const [selectedConustruction, setSelectedConustruction] = useState([]);
  const [selectedPostedBy, setSelectedPostedBy] = useState([]);
  const [propertyPrice, setPropertyPrice] = useState([]);

  useEffect(() => {
    dispatch(getSubCategory());
  }, [dispatch]);

  useEffect(() => {
    if (subCatTotal && subCatTotal.length > 0) {
      const filterSubcat = subCatTotal.filter(
        (data) => data.superCategory === "Residential" && data.category === "Sell"
      );
      if (filterSubcat.length > 0) {
        setShowSubcat(filterSubcat);
        setSelectedSubcat(filterSubcat.map((item) => item.name));
      }
    }
  }, [subCatTotal]);
  useEffect(() => {
    props.getSubcatDetails(selectedSubcat);
    props.getBudgetDetails(propertyPrice);
    props.getBedRoomDetails(selectedBedrooms);
    props.getConustructionDetails(selectedConustruction);
    props.getPostedDetailsDetails(selectedPostedBy);
  }, [
    selectedSubcat,
    propertyPrice,
    selectedBedrooms,
    selectedConustruction,
    selectedPostedBy,
  ]);

  useEffect(() => {
    const clickoutside = (e) => {
      if (showResults && ref.current && !ref.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.addEventListener("click", clickoutside);
    };
  }, [showResults]);
  useEffect(() => {
    setSelectedSubcat([...showSubcat.map((item) => item.name)]);
  }, [showSubcat]);

  const handleSubcatPress = (evt) => {
    if (selectedSubcat.includes(evt.target.value)) {
      setSelectedSubcat(
        selectedSubcat.filter((e) => {
          return e !== evt.target.value;
        })
      );
    } else {
      setSelectedSubcat((selectedSubcat) => [
        ...selectedSubcat,
        evt.target.value,
      ]);
    }
  };

  const handleBedroomPress = (selectvalue) => {
    if (selectedBedrooms.includes(selectvalue)) {
      setSelectedBedrooms(
        selectedBedrooms.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedBedrooms([...selectedBedrooms, selectvalue]);
    }
  };
  const handleConustructionPress = (selectvalue) => {
    if (selectedConustruction.includes(selectvalue)) {
      setSelectedConustruction(
        selectedConustruction.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedConustruction([...selectedConustruction, selectvalue]);
    }
  };
  const handlePostedByPress = (selectvalue) => {
    if (selectedPostedBy.includes(selectvalue)) {
      setSelectedPostedBy(
        selectedPostedBy.filter((value) => value !== selectvalue)
      );
    } else {
      setSelectedPostedBy([...selectedPostedBy, selectvalue]);
    }
  };

  const bhkapartments = [
    { id: "1", name: "+ 1 RK / 1 BHK" },
    { id: "2", name: "+ 2 BHK" },
    { id: "3", name: "+ 3 BHK" },
    { id: "4", name: "+ 4 BHK" },
    { id: "5", name: "+ 5 BHK" },
  ];

  const consustatus = [
    { id: "1", name: "Under Construction" },
    { id: "2", name: "Ready to move" },
  ];
  const propertyPost = [
    { id: "1", name: "Owner" },
    { id: "2", name: "Builder" },
    { id: "3", name: "Dealer" },
  ];

  console.log(showSubcat,"----")

  const handleClearAll = () => {
    setSelectedSubcat([]);
    setSelectedBedrooms([]);
    setSelectedConustruction([]);
    setSelectedPostedBy([]);
    setPropertyPrice([]);
  };

  return (
    <>
      <div className="dropdownbox" style={{ paddingTop: "0" }}>
        <div className="clear-div">
          <p onClick={handleClearAll} role="button">
            Clear All
          </p>
        </div>
        <div className="showsubcatbanner">
          {showSubcat.map((subcat, index) => (
            <div className="subcatBoxbann" key={`buy-subcat-${index}`}>
              <div
                className={`childlabel ${
                  selectedSubcat.includes(subcat.name) ? "active-pill" : ""
                }`}
              >
                <input
                  type="checkbox"
                  id={`buy-subcat-${index}`}
                  name="buy-subcat"
                  value={subcat.name}
                  checked={selectedSubcat.includes(subcat.name)}
                  onChange={(e) => handleSubcatPress(e, subcat.name)}
                />

                <label htmlFor={`buy-subcat-${index}`}>
                  {subcat.name}
                </label>
              </div>
            </div>
          ))}
        </div>

        <div className="label-caption">
          <p>
            Looking for commercial properties ?<a href="#">Click here</a>
          </p>
          <hr />
        </div>
        <div className="dropdown-lists">
          <div className="parent-box">
            <div
              className={`main-boxes ${toggle === "Budget" ? "active" : ""}`}
              onClick={() => setToggle(toggle === "Budget" ? "" : "Budget")}
            >
              <label>Budget</label>
              {toggle === "Budget" ? (
                <BsChevronUp className="arrowicon" />
              ) : (
                <BsChevronDown className="arrowicon" />
              )}
            </div>
            {toggle === "Budget" && (
              <div className="range-box">
                <div className="range-head">
                  <h6>Select Price Range</h6>
                </div>
                <div className="range-bar">
                  <label htmlFor="customRange2">0 - 100 Crores+</label>
                  <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    defaultValue={[0, 1000000000]}
                    max={1000000000}
                    min={0}
                    renderThumb={(props, state) => (
                      <div {...props}>{state.valueNow}</div>
                    )}
                    onChange={(value) => setPropertyPrice(value)}
                  />
                </div>
              </div>
            )}
          </div>

          <div className="parent-box">
            <div
              className={`main-boxes ${toggle === "Bedroom" ? "active" : ""}`}
              onClick={() => setToggle(toggle === "Bedroom" ? "" : "Bedroom")}
            >
              <label>Bedroom</label>
              {toggle === "Bedroom" ? (
                <BsChevronUp className="arrowicon" />
              ) : (
                <BsChevronDown className="arrowicon" />
              )}
            </div>
            {toggle === "Bedroom" && (
              <div className="bedroombox mediabedroom">
                <div className="bedroom-head">
                  <h6>Number of Bedrooms</h6>
                </div>
                <div className="boxes-parent">
                  {bhkapartments.map((bhk, index) => (
                    <div
                      key={index}
                      className={`pageComponent ${
                        selectedBedrooms.includes(bhk.id) ? "tags-and-chips_active__37Gi0 active" : ""
                      }`}
                      onClick={() => handleBedroomPress(bhk.id)}
                    >
                      <label>{bhk.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="parent-box">
            <div
              className={`main-boxes ${toggle === "Construction" ? "active" : ""}`}
              onClick={() => setToggle(toggle === "Construction" ? "" : "Construction")}
            >
              <label>Construction Status</label>
              {toggle === "Construction" ? (
                <BsChevronUp className="arrowicon" />
              ) : (
                <BsChevronDown className="arrowicon" />
              )}
            </div>
            {toggle === "Construction" && (
              <div className="bedroombox">
                <div className="construction-head">
                  <h6>Construction Status</h6>
                </div>
                <div className="construction-boxes">
                  {consustatus.map((data, index) => (
                    <div
                      key={index}
                      className={`pageComponent ${
                        selectedConustruction.includes(data.name)
                          ? "tags-and-chips_active__37Gi0 active"
                          : ""
                      }`}
                      onClick={() => handleConustructionPress(data.name)}
                    >
                      <label>{data.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="parent-box">
            <div
              className={`main-boxes ${toggle === "Posted" ? "active" : ""}`}
              onClick={() => setToggle(toggle === "Posted" ? "" : "Posted")}
            >
              <label>Posted By</label>
              {toggle === "Posted" ? (
                <BsChevronUp className="arrowicon" />
              ) : (
                <BsChevronDown className="arrowicon" />
              )}
            </div>
            {toggle === "Posted" && (
              <div className="bedroombox">
                <div className="posted-head">
                  <h6>Posted By</h6>
                </div>
                <div className="posted-main">
                  {propertyPost.map((data, index) => (
                    <div
                      key={index}
                      className={`pageComponent ${
                        selectedPostedBy.includes(data.name)
                          ? "tags-and-chips_active__37Gi0 active"
                          : ""
                      }`}
                      onClick={() => handlePostedByPress(data.name)}
                    >
                      <label>{data.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className=""></div>
      </div>
    </>
  );
};

export default BuySearchComponent;
